import styled from 'styled-components';
import {pulse} from '../../../styles/animations';

const Pulse = styled.div<{$w?: string; $h?: string; $round?: boolean; $light?: boolean}>`
	height: ${p => p.$h ?? '16px'};
	width: ${p => p.$w ?? '100%'};
	border-radius: ${p => (p.$round ? p.theme.ticketing.radius.full : '4px')};
	background: ${p => (p.$light ? '#f1f5f9' : '#e2e8f0')};
	animation: ${pulse} 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
`;
const Header = styled.div`
	margin-bottom: 24px;
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const BadgeRow = styled.div`
	display: flex;
	gap: 8px;
`;
const TabsRow = styled.div`
	display: flex;
	gap: 24px;
	border-bottom: 1px solid #e2e8f0;
	padding-top: 12px;
`;
const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: 24px;
	@media (min-width: 1024px) {
		grid-template-columns: 1fr 20rem;
	}
`;
const Column = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
const Panel = styled.div`
	border-radius: 8px;
	border: 1px solid #f1f5f9;
	background: #ffffff;
	padding: 16px;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
`;
const BigPanel = styled(Panel)`
	padding: 20px;
`;
const TimelineRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;
const TimelineBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
// 20px padding matches the loaded Details card and Watchers panel, so the
// skeleton → content swap doesn't shift the sidebar.
const Aside = styled.aside`
	border-radius: 8px;
	border: 1px solid #f1f5f9;
	background: #ffffff;
	padding: 20px;
	box-shadow: 0 1px 2px rgb(0 0 0 / 0.05);
	display: flex;
	flex-direction: column;
	gap: 12px;
`;
const AsideItem = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 0;
`;
const Breadcrumb = styled(Pulse)`
	margin-bottom: 16px;
`;

export function TicketDetailSkeleton() {
	return (
		<div aria-label="Loading ticket" aria-busy="true" role="status">
			<Breadcrumb $w="128px" />

			<Header>
				<BadgeRow>
					<Pulse $w="64px" $h="20px" />
					<Pulse $w="56px" $h="20px" $round />
					<Pulse $w="56px" $h="20px" $round />
				</BadgeRow>
				<Pulse $w="66%" $h="28px" />
				<Pulse $w="192px" />
				<TabsRow>
					{Array.from({length: 6}).map((_, i) => (
						<Pulse key={i} $w="64px" $light />
					))}
				</TabsRow>
			</Header>

			<Grid>
				<Column>
					<BigPanel>
						<Pulse $w="96px" />
						<div style={{marginTop: 12}}>
							<Pulse $h="48px" $light />
						</div>
					</BigPanel>
					{Array.from({length: 3}).map((_, i) => (
						<Panel key={i}>
							<TimelineRow>
								<Pulse $w="32px" $h="32px" $round />
								<TimelineBody>
									<Pulse $w="33%" $h="12px" />
									<Pulse $h="12px" $light />
									<Pulse $w="80%" $h="12px" $light />
								</TimelineBody>
							</TimelineRow>
						</Panel>
					))}
				</Column>

				<Column>
					<Aside>
						<Pulse $w="48px" />
						{Array.from({length: 7}).map((_, i) => (
							<AsideItem key={i}>
								<Pulse $w="64px" $h="12px" />
								<Pulse $w="80px" $h="12px" $light />
							</AsideItem>
						))}
					</Aside>
					<BigPanel>
						<Pulse $w="64px" />
						<div style={{marginTop: 12}}>
							<Pulse $h="32px" $light />
						</div>
					</BigPanel>
				</Column>
			</Grid>
		</div>
	);
}
